<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="結束輔導"
    cancelBtnText="取消"
    maxWidth="320"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <span class="subheading">{{dialogText}}</span>
    <template slot="action">
      <v-btn
        v-show="showCancelInvtieBtn"
        @click="cancelInvite"
        flat>
        取消邀請
      </v-btn>
    </template>
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '是否提前結束輔導?',
    showConfirmBtn: true,
    showCancelBtn: true,
    showCancelInvtieBtn: false
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoDto: state => state.fudaoDto,
      responseTimeout: state => state.responseTimeout
    })
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    }
  },

  beforeDestory() {
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoDto.id && this.fudaoDto.id !== domainEvent.body.id;
    },

    open() {
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.TeacherEndInvitationSent, this.onTeacherEndInvitationSent);
      // this.$eventBus.$off(FudaoEvent.StudentEndInvitationReceived, this.onStudentEndInvitationReceived);
      this.$eventBus.$off(FudaoEvent.StudentEndInvitationAccepted, this.onStudentEndInvitationAccepted);
      this.$eventBus.$off(FudaoEvent.StudentEndInvitationRejected, this.onStudentEndInvitationRejected);
      this.$eventBus.$off(FudaoEvent.StudentEndInvitationNoResponse, this.onStudentEndInvitationNoResponse);
      this.$eventBus.$off(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      clearTimeout(this._timeout);
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      this.loading = true;
      this.$eventBus.$on(FudaoEvent.TeacherEndInvitationSent, this.onTeacherEndInvitationSent);
      // this.$eventBus.$on(FudaoEvent.StudentEndInvitationReceived, this.onStudentEndInvitationReceived);
      this.$eventBus.$on(FudaoEvent.StudentEndInvitationAccepted, this.onStudentEndInvitationAccepted);
      this.$eventBus.$on(FudaoEvent.StudentEndInvitationRejected, this.onStudentEndInvitationRejected);
      this.$eventBus.$on(FudaoEvent.StudentEndInvitationNoResponse, this.onStudentEndInvitationNoResponse);
      this.$eventBus.$on(FudaoEvent.FudaoStartFailed, this.onFudaoStartFailed);

      await fudaoAppService.inviteEndFudaoAsync(this.fudaoDto.id);

      this._timeout = setTimeout(() => {
        this.sentNoResponse();
      }, this.responseTimeout);
    },

    cancel() {
      this.dialog = false;
    },

    async cancelInvite() {
      clearTimeout(this._timeout);
      await fudaoAppService.cancelEndFudaoInvition(this.fudaoDto.id);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseEndFuadoAsync(this.fudaoDto.id);
    },

    // events -------------------------------------

    onTeacherEndInvitationSent(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.dialogText = '已送出結束輔導邀請，等待對方回應...';
      this.showConfirmBtn = false;
      this.showCancelBtn = false;
      this.showCancelInvtieBtn = true;
    },

    // onStudentEndInvitationReceived(domainEvent) {
    // },

    async onStudentEndInvitationAccepted(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }

      clearTimeout(this._timeout);
      // TODO Asking Ned about endFudaoAsync() function return value.
      // Currently it does not return anything, but startFudaoAsync() does.
      await fudaoAppService.endFudaoAsync(this.fudaoDto.id);
      this.dialog = false;
    },

    onStudentEndInvitationRejected(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '學生拒絕結束輔導'});
      this.dialog = false;
    },

    onStudentEndInvitationNoResponse(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '邀請結束輔導無回應'});
      this.dialog = false;
    },

    onFudaoStartFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請結束輔導發生錯誤: ' + errMsg});
    }
  }
};
</script>